(function ($, Drupal, once) {
    Drupal.behaviors.ytPlayer = {
      attach: function (context, settings) {
        $(once('ytPlayer', '#mixed-food__videoplayer', context)).each(
          function() {
            var player;
            window.onYouTubeIframeAPIReady = function() {
              player = new YT.Player('mixed-food__videoplayer', {
                events: {
                  'onReady': onPlayerReady
                }
              });
              function onPlayerReady(event) {
                window.mixedFoodVideoplayer = event.target;
              }
            }
          }
        );
      }
    };
  })(jQuery, Drupal, once);
  